<template>
   <div class="no-vehicles">
        <p>You have no {{vehiclesCategory}} vehicles</p>
        <a href="inventory">Shop here</a>
    </div>
</template>

<script>
import {PAGES} from '../../shared/routes.constants'
export default {
  name: 'no-vehicles',
  props: {
    vehiclesCategory: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      inventoryUrl: PAGES.Inventory
    }
  }

}
</script>

<style scoped>
.no-vehicles{
    width: 100%;
    text-align: center;
}
.no-vehicles p{
    font-size: 1.5em;
    font-weight: 300;
    margin: 24px auto;
    max-width: 240px;
}
.no-vehicles a{
    font-weight: 600;
    color: #2C61D5;
}
</style>



// WEBPACK FOOTER //
// no-vehicles.vue?2d722fcc